import isNil from 'lodash/isNil';
import React from 'react';
import clsx from 'clsx';
import Row from 'pages/Dashboard/components/Row';
import {
  ChargeInfo,
} from 'pages/Dashboard/pages/Billing/types';
import ProviderIcon from 'pages/Dashboard/pages/Billing/Charges/columns/ProviderIcon';
import {
  getDisplayName,
} from 'pages/Dashboard/utils/helper';

type Parts = 'row';

type Props = {
  claim: Partial<ChargeInfo>;
  classes?: Partial<Record<Parts, string>>;
};

export default function ProviderTooltip({ claim, classes }: Props) {
  return (
    <div className="flex flex-col min-w-48">
      <div
        key={claim.claimId}
        className="flex flex-col w-fit max-w-full"
      >
        <Row
          title="Rendering Provider"
          className={clsx('flex flex-col w-full !items-start gap-2 !border-0 !mb-0', classes?.row)}
        >
          <div className="flex items-center gap-2">
            <ProviderIcon {...(claim?.renderingProvider ?? {})} />
            <span className="font-semibold whitespace-nowrap">
              {getDisplayName(claim.renderingProvider?.formattedNames, 'Not Set')}
            </span>
          </div>
        </Row>
        {!isNil(claim.claimId) && !isNil(claim.billingProvider) && (
          <Row
            title="Billing Provider"
            className={clsx('flex flex-col w-full !items-start gap-2 !border-0 !mb-0', classes?.row)}
          >
            <div className="flex items-center gap-2">
              <ProviderIcon {...(claim?.billingProvider ?? {})} />
              <span className="font-semibold whitespace-nowrap">
                {getDisplayName(claim.billingProvider?.formattedNames, 'Not Set')}
              </span>
            </div>
          </Row>
        )}
      </div>
    </div>
  );
}
